interface ImageWithFallbackProps {
    /** A bare Directus filename, or a full URL (Smart CMS stores those). */
    filename?: string;
    alt: string;
    className?: string;
    loading?: "lazy" | "eager";
}

const IMAGE_BASE_URL = "https://signpostdirectus.file.core.windows.net/uploads-prod/";
const IMAGE_QUERY_PARAMS =
    "sv=2022-11-02&ss=f&srt=sco&sp=rl&se=2027-10-19T22:27:11Z&st=2024-10-18T14:27:11Z&spr=https&sig=A04UaCGHA%2BwcuV4X1KpF5NCNxo7paTPelCT0YZpC8E8%3D";

export function ImageWithFallback({
    filename,
    alt,
    className = "",
    loading = "eager",
}: ImageWithFallbackProps) {
    // No image, or a non-string from a CMS field: render nothing rather than
    // a broken-image icon, or throwing on a string method with no error boundary.
    if (!filename || typeof filename !== "string") return null;

    // Full URLs pass through; bare Directus filenames get the blob prefix.
    const src = /^(https?:)?\/\//i.test(filename) || filename.startsWith("data:")
        ? filename
        : `${IMAGE_BASE_URL}${filename}?${IMAGE_QUERY_PARAMS}`;

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            decoding="async"
            loading={loading}
        />
    );
};
